import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApisService } from '@core/services/apis.service';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-edit-investor',
  templateUrl: './edit-investor.component.html',
  styleUrls: ['./edit-investor.component.scss']
})
export class EditInvestorComponent implements OnInit {

  @ViewChild('imageInput') imageInput!: ElementRef;
  
  productId: string | null = null;
  product: any = {
    name: '',
    email: '',
    employee_id: '',
    nationality: '',
    phone: '',
    identity_number: '',
    city_id: '',
    image: null,
  };
  
  employee: any = [];
  cities: any = [];
  countries: any = [];
  currentLang: string = 'ar';
  
  selectedFile: File | null = null;
  imagePreview: string | null = null;
  originalImage: string | null = null;
  isLoading: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private apiService: ApisService,
    private toastr: ToastrService,
    private translate: TranslateService
  ) {}

  ngOnInit(): void {
    this.currentLang = localStorage.getItem('currentLang') || 'ar';
    this.productId = this.route.snapshot.paramMap.get('id');
    
    if (!this.productId) {
      this.toastr.error(this.translate.instant('MENU.DASHBOARD.invalid_investor_id'));
      this.router.navigate(['/investors']);
      return;
    }
    
    this.getCountries();
    this.loadEmployees();
    this.loadProduct(this.productId);
  }

  loadProduct(id: string): void {
    this.isLoading = true;

    this.apiService.getInvestorById(id).subscribe({
      next: (res: any) => {
        if (res?.data) {
          this.product = { ...res.data };

          // 🔥 تصحيح معالجة الجنسية - إذا كانت nationality كائن
          if (res.data.nationality && typeof res.data.nationality === 'object') {
            this.product.nationality = res.data.nationality.id.toString();
          } else {
            this.product.nationality = res.data.nationality?.toString() || '';
          }

          // معالجة city_id
          if (res.data.city_id) {
            this.product.city_id = res.data.city_id.toString();
          } else if (res.data.city?.id) {
            this.product.city_id = res.data.city.id.toString();
          }

          console.log('🌍 Nationality after processing:', this.product.nationality);
          console.log('🏙️ City ID after processing:', this.product.city_id);

          // تحميل المدن بناءً على الجنسية بعد معالجة البيانات
          setTimeout(() => {
            if (this.product.nationality) {
              this.getCities(this.product.nationality);
            }
          }, 100);

          this.originalImage = res.data.image;
          this.imagePreview = res.data.image;
          this.product.image = res.data.image;
        }

        this.isLoading = false;
      },
      error: () => {
        this.isLoading = false;
        this.toastr.error(
          this.translate.instant('MENU.DASHBOARD.failed_to_load_investor')
        );
      },
    });
  }

  loadEmployees(): void {
    this.apiService.employee().subscribe({ 
      next: (response: any) => { 
        this.employee = response.data || [];
      }, 
      error: (err) => { 
        console.log('Error fetching employees:', err);
        this.toastr.error(this.translate.instant('MENU.DASHBOARD.failed_to_load_employees'));
      }
    });
  }

  getCountries(): void {
    this.apiService.getCountriesM().subscribe({ 
      next: (response: any) => { 
        this.countries = response.data || [];
        console.log('🌍 Countries loaded:', this.countries);
        
        // بعد تحميل الدول، تأكد من تعيين الجنسية بشكل صحيح
        if (this.product.nationality && this.countries.length > 0) {
          this.ensureNationalityIsSet();
        }
      }, 
      error: (err) => { 
        console.log('Error fetching countries:', err);
        this.toastr.error(this.translate.instant('MENU.DASHBOARD.failed_to_load_countries'));
      }
    });
  }

  // 🔥 دالة جديدة للتأكد من تعيين الجنسية بشكل صحيح
  ensureNationalityIsSet(): void {
    if (this.product.nationality && this.countries.length > 0) {
      const countryExists = this.countries.find((c: any) => c.id == this.product.nationality);
      if (!countryExists) {
        console.warn('Country not found in list, resetting nationality');
        this.product.nationality = '';
        this.cities = [];
        this.product.city_id = '';
      }
    }
  }

  onNationalityChange(): void {
    console.log('🔄 Nationality changed to:', this.product.nationality);
    this.product.city_id = ''; // إعادة تعيين المدينة
    if (this.product.nationality) {
      this.getCities(this.product.nationality);
    } else {
      this.cities = [];
    }
  }

getCities(nationalityId: string): void {
  console.log('🏙️ Fetching cities for country:', nationalityId);

  this.apiService.getCitiesById(nationalityId).subscribe({
    next: (response: any) => {

      // 🔥 Convert SINGLE object → ARRAY
      const data = response.data;
      this.cities = data ? [data] : [];
      this.cities = response.data || [];

      console.log('🏙️ Cities loaded:', this.cities);

      if (this.product.city_id && this.cities.length > 0) {
        this.product.city_id = this.cities[0].id.toString(); // Auto select
      }
    },
    error: (err) => {
      console.log('Error fetching cities:', err);
      this.cities = [];
      this.toastr.error(this.translate.instant('MENU.DASHBOARD.failed_to_load_cities'));
    }
  });
}


  // 🔥 دالة جديدة للتأكد من تعيين المدينة بشكل صحيح
  ensureCityIsSet(): void {
    if (this.product.city_id && this.cities.length > 0) {
      const cityExists = this.cities.find((c: any) => c.id == this.product.city_id);
      if (!cityExists) {
        console.warn('City not found in list, resetting city');
        this.product.city_id = '';
      }
    }
  }

  onFileSelected(event: any): void {
    const file = event.target.files[0];
    
    if (file) {
      if (!file.type.startsWith('image/')) {
        this.toastr.error(this.translate.instant('VALIDATION.invalid_image_type'));
        this.resetImageInput();
        return;
      }
      
      if (file.size > 5 * 1024 * 1024) {
        this.toastr.error(this.translate.instant('VALIDATION.image_size_exceeded'));
        this.resetImageInput();
        return;
      }
      
      this.selectedFile = file;
      
      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.imagePreview = e.target.result;
        this.product.image = e.target.result;
      };
      reader.readAsDataURL(file);
    }
  }

  removeImage(): void {
    this.selectedFile = null;
    this.imagePreview = null;
    this.product.image = null;
    this.resetImageInput();
  }

  private resetImageInput(): void {
    if (this.imageInput?.nativeElement) {
      this.imageInput.nativeElement.value = '';
    }
  }

  updateProduct(): void {
    if (!this.productId) {
      this.toastr.error(this.translate.instant('MENU.DASHBOARD.invalid_investor_id'));
      return;
    }

    if (!this.isFormValid()) {
      this.toastr.error(this.translate.instant('MENU.VALIDATION.fill_all_required_fields'));
      return;
    }

    this.isLoading = true;
    const formData = new FormData();
    
    // إضافة البيانات النصية
    formData.append('name', this.product.name || '');
    formData.append('email', this.product.email || '');
    formData.append('employee_id', this.product.employee_id || '');
    formData.append('identity_number', this.product.identity_number || '');
    formData.append('phone', this.product.phone || '');
    formData.append('city_id', this.product.city_id?.toString() || '');
    formData.append('nationality', this.product.nationality || '');

    // معالجة الصورة
    if (this.selectedFile) {
      formData.append('image', this.selectedFile, this.selectedFile.name);
    } else if (!this.product.image && this.originalImage) {
      // إذا تمت إزالة الصورة
      formData.append('remove_image', 'true');
    }

    this.logFormData(formData);

    this.apiService.editInvestor(this.productId, formData).subscribe({
      next: (response) => {
        console.log('Update successful:', response);
        this.toastr.success(this.translate.instant('MENU.DASHBOARD.investor_updated_successfully'));
        this.router.navigate(['/investors']);
        this.isLoading = false;
      },
      error: (err) => {
        console.error('Update failed:', err);
        this.handleError(err);
        this.isLoading = false;
      },
    });
  }

  private isFormValid(): boolean {
    return !!(
      this.product.name?.trim() && 
      this.product.phone?.trim() && 
      this.product.identity_number?.trim() && 
      this.product.employee_id && 
      this.product.city_id && 
      this.product.nationality
    );
  }

  private handleError(err: any): void {
    let errorMessage = this.translate.instant('MENU.DASHBOARD.failed_to_update_investor');
    
    if (err.error?.message) {
      errorMessage = err.error.message;
    } else if (err.error?.errors) {
      const errors = err.error.errors;
      const errorMessages: string[] = [];
      Object.values(errors).forEach((error: any) => {
        if (Array.isArray(error)) {
          errorMessages.push(...error);
        } else {
          errorMessages.push(error);
        }
      });
      errorMessage = errorMessages.join(', ');
    }
    
    this.toastr.error(errorMessage);
  }

  private logFormData(formData: FormData): void {
    console.log('=== FormData Contents ===');
    for (let pair of (formData as any).entries()) {
      if (pair[0] === 'image') {
        console.log('📷 image:', pair[1] instanceof File ? 
          `File: ${pair[1].name}, Size: ${pair[1].size} bytes` : 
          pair[1]
        );
      } else {
        console.log(`${pair[0]}: ${pair[1]}`);
      }
    }
  }
}
